<template>
    <div class="row">
        <toggle-route :parent-home-delivery="this.homeDelivery" @routeToggled="this.routeToggled"></toggle-route>
        <check-availability
            :postcode="this.updatedPostcode"
            @updatedPostcode="updatePostcode"
        ></check-availability>
    </div>
</template>

<script>
    import url_filters from '@shared/mixins/url_filters';
    export default {
        props: [
			'homeDeliveryRoute',
            'postcode'
        ],
		mixins: [url_filters],
        data() {
            return {
                updatedPostcode: this.postcode
            }
        },
        methods: {
            updatePostcode(value) {
				this.updatedPostcode = value;
			}
        }
    }
</script>

<style lang="scss" scoped>

</style>